import React from 'react';

const FallingCross = (props) => (
	<svg
		viewBox="0 0 169 168"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			id='cross-path'
			d="M113.178 76.4785L144.885 21.5606L108.273 0.422695L76.5665 55.3406L21.6486 23.6337L0.510677 60.2457L55.4286 91.9526L23.7217 146.87L60.3337 168.008L92.0405 113.09L128.652 134.228L146.958 144.797L168.096 108.185L113.178 76.4785Z"
			fill="#E41F13"
			stroke="#E41F13"
			strokeWidth={1.5}
		/>
	</svg>
);

export default FallingCross;
